export default {
    default_locale: 'fr_FR',
    url_api: __DEV__
        ? 'http://localhost:3001'
        : __SERVER__ === 'production'
            ? 'https://api.portal.solidom.net'
            : 'https://qualif.api.portal.solidom.net',
    timeout_socket: 30000,
    timeout_api: 15000,
    timeout_socket_order: 15000,
    timeout_long_socket_order: 60000,

    environments:
        __SERVER__ === 'production'
            ? ['fhe', 'myfhe', /*'fhepool',*/ 'cocoon', 'fheconnect', 'homing', 'lacin', 'domalisa', 'accesshabitat', /*'maestro',*/ /*'simulationenr',*/, 'idealys', 'inogreen', 'weezeo', 'testbench', /*'ticketsgit',*/ 'logging']
            : ['fhe', 'myfhe', 'cocoon', 'fheconnect', 'homing', 'lacin', 'domalisa', 'accesshabitat', 'maestro', 'simulationenr', 'testbench', 'ticketsgit', 'logging'],

    googleApi: {
        redirectUrl: 'net.solidom.electron.fhe-support:/',
        clientId: '491047829615-sib8kgdugcvhtv7nnjfl3prchdts1gqp.apps.googleusercontent.com',
        clientIdWeb: '491047829615-8loh62g0jmitj9b1rjqs85v7hua6rpnv.apps.googleusercontent.com',
        scope: 'email',
        grantType: 'authorization_code',
        GOOGLE_AUTHORIZATION_URL: 'https://accounts.google.com/o/oauth2/v2/auth',
        GOOGLE_TOKEN_URL: 'https://www.googleapis.com/oauth2/v4/token',
        GOOGLE_PROFILE_URL: 'https://www.googleapis.com/userinfo/v2/me'
    },
    clientInterface: {
        cocoon: 'http://dev.fullhomeenergy.fr/connexion/support/',
        fheconnect: 'http://dev.fullhomeenergy.fr/connexion/support/',
        fhe: 'http://dev.fullhomeenergy.fr/connexion/support/'
    }
};



// WEBPACK FOOTER //
// C:/FHE/Support/support-react-application/conf/index.js